import React, { useState } from 'react';
import { Nav } from "shards-react";

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Store } from '../../../flux';
import DropdownsMenuApplications from "./menuHelper/DropdownsMenuApplications";
import SidebarNavItem from './SidebarNavItem';

const SidebarNavItems = (props) => {

    const { _store } = props;
    const [items, setItems] = useState(_store.navItems);

    useEffect(() => {
        // Store.addChangeListener( () => { Store.getSidebarItems() } );
        Store.addChangeListener( () => { return _store.navItems } );
    
        return () => {
            // Store.removeChangeListener( () => { Store.getSidebarItems() } );
            Store.removeChangeListener( () => { return _store.navItems } );
        };
    }, []);

    return (
        <div className="nav-wrapper">
            <Nav className="nav--no-borders flex-column">
                {items.map((item, idx) => (
                    <SidebarNavItem key={idx} item={item} />
                ))}
                <DropdownsMenuApplications />
            </Nav>
        </div>
    )
};

SidebarNavItems.contextTypes = {
    t: PropTypes.func
  }

export default SidebarNavItems;
